module.exports = __webpack_public_path__ + "static/instagram-568e900a40d9e0e58c67a8fce141a4d8.png";